var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8147_144006)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 26,
    height: 26,
    rx: 4,
    fill: "#272A3A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8C9 7.44772 9.44772 7 10 7H20C20.5523 7 21 7.44772 21 8V14.5C21 14.7761 20.7761 15 20.5 15C20.2239 15 20 14.7761 20 14.5V8H10V22H13V19.5C13 19.2239 13.2239 19 13.5 19H15V23H10C9.44771 23 9 22.5523 9 22V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9C11.2239 9 11 9.22386 11 9.5V10.5C11 10.7761 11.2239 11 11.5 11H12.5C12.7761 11 13 10.7761 13 10.5V9.5C13 9.22386 12.7761 9 12.5 9H11.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9C14.2239 9 14 9.22386 14 9.5V10.5C14 10.7761 14.2239 11 14.5 11H15.5C15.7761 11 16 10.7761 16 10.5V9.5C16 9.22386 15.7761 9 15.5 9H14.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9C17.2239 9 17 9.22386 17 9.5V10.5C17 10.7761 17.2239 11 17.5 11H18.5C18.7761 11 19 10.7761 19 10.5V9.5C19 9.22386 18.7761 9 18.5 9H17.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C11.2239 12 11 12.2239 11 12.5V13.5C11 13.7761 11.2239 14 11.5 14H12.5C12.7761 14 13 13.7761 13 13.5V12.5C13 12.2239 12.7761 12 12.5 12H11.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12C14.2239 12 14 12.2239 14 12.5V13.5C14 13.7761 14.2239 14 14.5 14H15.5C15.7761 14 16 13.7761 16 13.5V12.5C16 12.2239 15.7761 12 15.5 12H14.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12C17.2239 12 17 12.2239 17 12.5V13.5C17 13.7761 17.2239 14 17.5 14H18.5C18.7761 14 19 13.7761 19 13.5V12.5C19 12.2239 18.7761 12 18.5 12H17.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15C11.2239 15 11 15.2239 11 15.5V16.5C11 16.7761 11.2239 17 11.5 17H12.5C12.7761 17 13 16.7761 13 16.5V15.5C13 15.2239 12.7761 15 12.5 15H11.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15C14.2239 15 14 15.2239 14 15.5V16.5C14 16.7761 14.2239 17 14.5 17H15.5C15.7761 17 16 16.7761 16 16.5V15.5C16 15.2239 15.7761 15 15.5 15H14.5Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8855 16.4595C19.0661 15.8468 19.9339 15.8468 20.1145 16.4595L20.1583 16.6081C20.2737 16.9996 20.7209 17.1849 21.0793 16.9896L21.2154 16.9155C21.7763 16.61 22.39 17.2237 22.0845 17.7846L22.0104 17.9207C21.8151 18.2791 22.0004 18.7263 22.3919 18.8417L22.5405 18.8855C23.1532 19.0661 23.1532 19.9339 22.5405 20.1145L22.3919 20.1583C22.0004 20.2737 21.8151 20.7209 22.0104 21.0793L22.0845 21.2154C22.39 21.7763 21.7763 22.39 21.2154 22.0845L21.0793 22.0104C20.7209 21.8151 20.2737 22.0004 20.1583 22.3919L20.1145 22.5405C19.9339 23.1532 19.0661 23.1532 18.8855 22.5405L18.8417 22.3919C18.7263 22.0004 18.2791 21.8151 17.9207 22.0104L17.7846 22.0845C17.2237 22.39 16.61 21.7763 16.9155 21.2154L16.9896 21.0793C17.1849 20.7209 16.9996 20.2737 16.6081 20.1583L16.4595 20.1145C15.8468 19.9339 15.8468 19.0661 16.4595 18.8855L16.6081 18.8417C16.9996 18.7263 17.1849 18.2791 16.9896 17.9207L16.9155 17.7846C16.61 17.2237 17.2237 16.61 17.7846 16.9155L17.9207 16.9896C18.2791 17.1849 18.7263 16.9996 18.8417 16.6081L18.8855 16.4595ZM21 19.5C21 18.6716 20.3284 18 19.5 18C18.6716 18 18 18.6716 18 19.5C18 20.3284 18.6716 21 19.5 21C20.3284 21 21 20.3284 21 19.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8147_144006",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8147_144006"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8147_144006",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageRooms);
export default __webpack_public_path__ + "static/media/manage-rooms.2939a7b6b0d1b11da5631558e85c677d.svg";
export { ForwardRef as ReactComponent };